import React from 'react';
import { string } from 'prop-types';
import objectPath from 'object-path';
import {
  incomeGeneralImg,
  incomeEaseImg,
  incomeRelevanceImg,
  addressEaseImg,
  addressRelevanceImg,
  nameEaseImg,
} from './images';

const reviewMap = {
  income: {
    A: {
      image: incomeGeneralImg,
      content: (
        <span>
          &quot;...<b>Thanks to LendingClub</b> I was able to get the money I needed, and it only took 1 business day to
          complete the application process...&quot;*
        </span>
      ),
      reviewer: 'Beronica from Arizona',
      disclaimer: 'This is Beronica’s experience. Individual results may vary.',
    },
    B: {
      image: incomeRelevanceImg,
      content: (
        <span>
          &quot;The loan process was very easy! I answered some <b>basic questions like income, </b>
          where I live, and where I work...and the next day I was approved...&quot;*
        </span>
      ),
      reviewer: 'Javier from California',
      disclaimer: 'This is Javier’s experience. Individual results may vary.',
    },
    C: {
      image: incomeEaseImg,
      content: (
        <span>
          &quot;The application process was <b>surprisingly easy</b> and I received a great rate. The customer service
          was excellent and my representative kept me updated frequently. I saved over $7,400 with my new rate.&quot;*
        </span>
      ),
      reviewer: 'Sunsannah from Georgia',
      disclaimer: 'This is Sunsannah’s experience. Individual results may vary.',
    },
  },
  name: {
    A: {
      image: nameEaseImg,
      content: (
        <span>
          &quot;I started the application and got approved in less than an hour.
          <b>Couldn’t be easier to use</b> and saved me $100 a month in credit card fees.&quot;*
        </span>
      ),
      reviewer: 'Carol from New Jersey',
      disclaimer: 'This is Carol’s experience. Individual results may vary.',
    },
  },
  address: {
    A: {
      image: addressEaseImg,
      content: (
        <span>
          &quot;LendingClub was so <b>helpful and easy</b> with their online loan process. I was able to get an
          unsecured loan quickly for debt consolidation, saving me over $500 in payments each month.&quot;*
        </span>
      ),
      reviewer: 'Cynthia from Nebraska',
      disclaimer: 'This is Cynthia’s experience. Individual results may vary.',
    },
    B: {
      image: addressRelevanceImg,
      content: (
        <span>
          &quot;This loan was so easy to apply for...After one quick phone call to <b>verify my address</b> I got an
          email stating I was approved. The funds were in my account the next day!...&quot;*
        </span>
      ),
      reviewer: 'Lindsay from New York',
      disclaimer: 'This is Lindsay’s experience. Individual results may vary.',
    },
  },
};

const SocialProof = ({ card, variant }) => {
  if (!card || !variant) return null;

  const review = objectPath.get(reviewMap, `${card}.${variant}`);
  return (
    <div className="social-proof">
      <div className="social-proof__image">
        <img src={review.image} alt="person icon" />
      </div>
      <div className="social-proof__content">
        {review.content}
        <div className="social-proof__reviewer">– {review.reviewer}</div>
        <div className="social-proof__disclaimer">* {review.disclaimer}</div>
      </div>
    </div>
  );
};

SocialProof.propTypes = {
  card: string.isRequired,
  variant: string.isRequired,
};

export default SocialProof;

require('/var/lib/jenkins/workspace/borrower-apply-ui_Release_0/src/pages/pi1-1QAAT/components/SocialProof/SocialProof.scss');